// ags-line-button-control-factory.ts
import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsLineButtonControl } from "../ags-line-button-controls";

export class AgsLineButtonControlFactory implements ControlFactory {
    
    /**
     * Determines whether the factory can create controls based on the current layer.
     * @param layer The Layers object to check.
     * @returns A boolean value indicating whether the factory can create controls based on the current layer.
     */
    public filter(layer: Layers): boolean {
        return (
            layer.getFlexiButton("line_slider_up") != null &&
            layer.getFlexiButton("line_slider_down") != null
        );
    }

    /**
     * Builds a collection of AgsLineButtonControl objects based on the current layer.
     * @param layer The Layers object to use when building the control collection.
     * @returns A collection of AgsLineButtonControl objects based on the current layer.
     */
    public build(layer: Layers): AgsLineButtonControl[] {

        const incrementBet = layer.getFlexiButton("line_slider_up");
        const decrementBet = layer.getFlexiButton("line_slider_down");

        return [
            new AgsLineButtonControl(incrementBet, true),
            new AgsLineButtonControl(decrementBet, false),
        ];
    }
}
